import React from 'react';
import type { Location } from '../../app/ApiGen';
import { singleLineAddress } from '../../components/Address';
import { TableLink } from '../../components/Link';
import type { Column } from '../dataTable/columns';
import type { Normalised } from '../request';
import { addressIncludesSearch } from '../search';
import { sortByAddress, sortByLocale } from '../sortBy';

export type TableLocation = Pick<Normalised<Location>, 'address' | 'icpNumber' | 'id' | 'name'> & {
  chargePointCount: number;
  gridExitPoint?: string;
  electricityDistributor?: string;
  electricityRetailer?: string;
};

export function tableColumns<L extends TableLocation>(args: {
  getUrl: (location: L) => string;
}): Record<keyof Omit<TableLocation, 'id'>, Column<L>> {
  const { getUrl } = args;
  return {
    address: {
      field: 'address',
      title: 'Address',
      render: singleLineAddress,
      customSort: sortByAddress('address'),
      customFilterAndSearch: (search: unknown, { address }) => addressIncludesSearch(address, search),
      width: '35%',
    },
    chargePointCount: { field: 'chargePointCount', title: 'Charge points', width: '5%' },
    electricityDistributor: {
      field: 'electricityDistributor',
      title: 'Electricity Distributor',
      hidden: true,
      width: '15%',
    },
    electricityRetailer: { field: 'electricityRetailer', title: 'Electricity Retailer', hidden: true, width: '15%' },
    gridExitPoint: { field: 'gridExitPoint', title: 'GXP', hidden: true, width: '10%' },
    icpNumber: { field: 'icpNumber', title: 'ICP/NMI number', hidden: true, width: '10%' },
    name: {
      field: 'name',
      title: 'Name',
      defaultSort: 'asc',
      customSort: sortByLocale('name'),
      render: (location) => <TableLink to={getUrl(location)}>{location.name}</TableLink>,
      name: '20%',
    },
  };
}
